import type { PreviewIntegration } from '@/modules/Workspaces/KnowledgeHub/Integrations/integrationTypes'

export const oneDriveIntegration: PreviewIntegration = {
  id: 'onedrive',
  name: 'Microsoft OneDrive',
  description:
    'Connect your OneDrive files and folders to Go for enhanced AI context and insights.',
  icon: 'onedrive-logo',
}
